import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Select from "react-select";
import AOS from "aos";
import "aos/dist/aos.css";
import queryString from 'query-string';
import { useLocation } from "react-router-dom";
import {
  AkademikDergiler,
  PopulerDergiler,
  Kitaplar,
  BildiriVeArmaganlar,
  DinBilimleri,
  TipKitaplari,
  KolayErisim,
  GuvenilirIcerik,
  KonuYelpazesi,
  DostuArayuz,
  BilgiKaynaklarimiz,
  HizlicaBulun,
  VerimliKullanin,
  HaberdarOlun,
  Halkalar,
  Ref1, Ref2, Ref3, Ref4, Ref5, Ref6,
} from "../imagepath";
import { Footer2 } from "../footer2";
import Header from "../header/index";
import {
  Course10,
  Pattern1
} from "../imagepath";
import { AppContext } from "../../services/AuthContext";
import { userInstutationDatabases } from '../../services/userService';
import "./home.css";
import { use } from "react";
import { getAramaBarText, getKartlarList, getBilgiKaynaklarimiz } from "../../services/directusService";
import { getPublicationTypeList } from "../../services/publicationService";
import { Helmet } from "react-helmet-async";
import ChapterCover from "./ChapterCover";
import axiosInstance from "../../services/axiosInstance";
import usePageTracking from "../../hooks/usePageTracking";
// Spinner bileşeni
const OrangeSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
    <div className="spinner-border" role="status" style={{ color: '#30a535ff', width: '3rem', height: '3rem' }}>
      <span className="visually-hidden">Yükleniyor...</span>
    </div>
  </div>
);

// --- KART ALTINDA TEK SATIRLIK BİLGİYİ ÜRETMEK İÇİN YARDIMCILAR ---

// herhangi bir dizide "attributename === name" olan ilk değeri güvenli çek
const getFrom = (name, arr = []) =>
  arr?.find(a => a?.attributename === name)?.value?.[0]?.value?.[0] || "";

// ilk dolu değeri döndür
const first = (...vals) => vals.find(v => !!v) || "";

// herhangi bir tarih benzeri stringten sadece yılı (YYYY) al
const getYearOnly = (value) => {
  if (!value) return "";
  const m = String(value).match(/\d{4}/);
  return m ? m[0] : "";
};

// ebeveyn (dergi/kitap) başlığı
const getParentTitle = (pub, idx = 0) =>
  getFrom("Dergi Adı", pub?.parentList?.[idx]?.publicationtypeInfo || []) ||
  getFrom("Başlık", pub?.parentList?.[idx]?.publicationtypeInfo || []) ||
  "";

// yayıncı kısa adı > yoksa tam adı
const getPublisherShort = (obj) =>
  obj?.publishers?.[0]?.sorttitle || obj?.publishers?.[0]?.title || "";

// cilt/sayı
const getIssue = (pub) =>
  getFrom("Sayı", pub?.publicationtypeInfo || []) ||
  getFrom("Sayı", pub?.parentList?.[0]?.publicationtypeInfo || []) || "";

const getVolume = (pub) =>
  getFrom("Cilt", pub?.publicationtypeInfo || []) ||
  getFrom("Cilt", pub?.parentList?.[0]?.publicationtypeInfo || []) || "";

// yılı gevşekçe bul (birkaç olası yerden)
const getYearLoose = (pub) => getYearOnly(first(
  getFrom("Yayın Tarihi", pub?.templateInfo || []),
  getFrom("Yayın Tarihi", pub?.publicationtypeInfo || []),
  getFrom("Yayın Tarihi", pub?.parentList?.[0]?.publicationtypeInfo || []),
  getFrom("Yayın Tarihi", pub?.parentList?.[1]?.publicationtypeInfo || [])
));

const getDateLoose = (pub) => first(
  getFrom("Yayın Tarihi", pub?.templateInfo || []),
  getFrom("Yayın Tarihi", pub?.publicationtypeInfo || []),
  getFrom("Yayın Tarihi", pub?.parentList?.[0]?.publicationtypeInfo || []),
  getFrom("Yayın Tarihi", pub?.parentList?.[1]?.publicationtypeInfo || [])
);

// akademik/popüler öneklerini kaldır display için (sadece kitap ve kitap bölümleri için)
const normalizeTypeDisplay = (type) => {
  const normalized = String(type).toLowerCase('tr-TR');
  if (normalized.includes('kitap')) {
    return String(type).replace(/^\s*(akademik\s+|popüler\s+|populer\s+)/i, '').trim();
  }
  return String(type);
};

// tür-özel kısa satır parçalarını döndür (array)
// Makale:  Dergi adı | Sayı | Tarih
// Kitap:   Yayıncı kısa adı/adı | Tarih   (NOT: sayı bilgisi yok)
// Bölüm:   Kitap adı | Tarih | (varsa) Yayıncı kısa adı
// Dergi sayısı: Dergi adı | Cilt | Sayı  (basic)
function buildInlineParts(pub) {
  const t = (pub?.publicationtype || "").toLocaleLowerCase("tr-TR");

  if (t.includes("makale") || t.includes("yazı")) {
    const journal = getParentTitle(pub, 1) || getParentTitle(pub, 0);
    const issue = getIssue(pub);
    const year = getYearLoose(pub);
    return [journal, issue ? `Sayı ${issue}` : "", year].filter(Boolean);
  }

  if (t === "akademik kitap" || t === "popüler kitap" || t === "populer kitap") {
    const publisher = getPublisherShort(pub);
    const year = getYearLoose(pub);
    return [publisher, year].filter(Boolean);
  }

  if (t.includes("bölüm")) {
    const bookTitle = getParentTitle(pub, 0);
    const year = getYearOnly(getFrom("Yayın Tarihi", pub?.parentList?.[0]?.publicationtypeInfo || [])) || getYearLoose(pub);
    const publisher = getPublisherShort(pub?.parentList?.[0]) || getPublisherShort(pub);
    return [bookTitle, year, publisher].filter(Boolean);
  }

  if (t === "popüler dergi sayısı" || t === "populer dergi sayisi" || t === "dergi sayısı" || t === "dergi sayisi") {
    const journal = getParentTitle(pub, 0);
    const vol = getVolume(pub);
    const iss = getIssue(pub);
    return [journal, vol ? `Cilt ${vol}` : "", iss ? `Sayı ${iss}` : ""].filter(Boolean);
  }

  return [];
}


export const Home2 = () => {
  usePageTracking("home");
  const { pathname } = useLocation();

  useEffect(() => {
    // Anında yukarı sıfırla (hiç animasyon yok)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant"
    });
  }, [pathname]);



  const navigate = useNavigate();
  const { auth } = useContext(AppContext);

  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [publication, setPublications] = useState([]);
  const [userDatabase, setUserDatabase] = useState(null);
  const [fetchedDBs, setFetchedDBs] = useState([]);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState("Tümü");

  const [selectedDatabase, setSelectedDatabase] = useState("");
  // arama modu: "all" | "yazar" | "dergi" | "kitap"
  const [quickKind, setQuickKind] = useState("all");
  const [catAggs, setCatAggs] = useState([]);   // {label, value} listesi
  const [catLoading, setCatLoading] = useState(false);
  const [topicAggs, setTopicAggs] = useState([]); // [{ label, value }]

  // pbtype: publicationTypes; publicationtypeinfo: publicationtypeInfo bloklarından agg
  const mapCategoryToAggrType = (category) => {
    switch (category) {
      case "documentTypes": return "pbtype";               // yayın türleri
      case "topicTitles": return "publicationtypeinfo";  // Konu Başlıkları
      case "databases": return "databases";
      case "publishers": return "publishers";
      case "journals": return "journals";
      case "languages": return "languages";            // gerekirse
      case "keywords": return "keywords";             // gerekirse
      default: return category;
    }
  };


  // Değer string/number ise string'e çevirir; object ise title/name/value/label içinden ilk bulduğunu alır.
  // array gelirse içindekileri virgülle birleştirir.
  const asText = (x) => {
    if (x == null) return "";
    if (typeof x === "string" || typeof x === "number") return String(x);
    if (Array.isArray(x)) return x.map(asText).filter(Boolean).join(", ");
    if (typeof x === "object") return x.title || x.name || x.value || x.label || "";
    return "";
  };

  const refLogos = [
    { src: Ref1, alt: "Kurum 1" },
    { src: Ref2, alt: "Kurum 2" },
    { src: Ref3, alt: "Kurum 3" },
    { src: Ref4, alt: "Kurum 4" },
    { src: Ref5, alt: "Kurum 5" },
  ];


  const [selectedFilters, setSelectedFilters] = useState({
    publicationAdvantageSearchDTOList: [
      {
        typename: "all",
        attributename: "",
        searchkeyword: "*",
        operator: "or",
      },
    ],
    permission: -1,
    databases: [],
    languages: [],
    documentTypes: [],
    keywords: [],
    publishers: [],
    topicTitles: [],
    startyear: "",
    endyear: "",
    journals: [],
    status: 1,
  });

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 800,
      easing: 'cubic-bezier(0.33, 1, 0.68, 1)', // easeOutCubic: sonda yumuşak yavaşlama
      once: true,
      mirror: false,
      anchorPlacement: 'top-bottom',
      // startEvent: 'load',
      disable: () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
    });

  }, []);

  const splitToCols = (arr, cols = 4) => {
    const out = Array.from({ length: cols }, () => []);
    arr.forEach((item, i) => out[i % cols].push(item));
    return out;
  };


  // component içine util: güvenli okuma
  const safeGet = (arr = [], key) =>
    (arr.find(x => x?.key === key)?.value) || 0;

  // Kategoriler için tek seferde aggr çek
  // component içine util: normalizasyon + güvenli toplama
  const norm = (s = "") =>
    s
      .toLocaleLowerCase("tr")
      .replaceAll("&", "ve")
      .replaceAll("ı", "i").replaceAll("ş", "s").replaceAll("ğ", "g")
      .replaceAll("ü", "u").replaceAll("ö", "o").replaceAll("ç", "c")
      .replace(/\s+/g, " ")
      .trim();

  const countFrom = (arr = [], keys = []) => {
    const set = new Set(keys.map(norm));
    return arr.reduce((sum, it) => sum + (set.has(norm(it?.key)) ? Number(it?.value || 0) : 0), 0);
  };

  const loadCategoryAggs = async () => {
    setCatLoading(true);
    const headers = auth.token ? { Authorization: `Bearer ${auth.token}` } : {};

    const dynamicFilters = { ...selectedFilters, databases: [] };

    try {
      const resp = await axiosInstance.post(
        "publicationSearch/advantageAggrSearchElastic?page=1&newpagesize=20",
        dynamicFilters,
        { headers }
      );

      const journalsResp = await axiosInstance.post(
        "publicationSearch/AtoZJournalsCount",
        {
          databasename: [],
          searchkeyword: "",
          topicname: "",
          searchtype: ""
        },
        { headers }
      );

      const journalCount = journalsResp?.data?.data?.count || 0;

      const data = resp?.data?.data ?? {};
      const types = data?.publicationTypes ?? [];   // [{key,value}]
      const dbs = data?.databases ?? [];         // [{key,value}]

      // yardımcılar
      const norm = (s = "") => s.toLocaleLowerCase("tr")
        .replaceAll("&", "ve")
        .replaceAll("ı", "i").replaceAll("ş", "s").replaceAll("ğ", "g")
        .replaceAll("ü", "u").replaceAll("ö", "o").replaceAll("ç", "c")
        .replace(/\s+/g, " ").trim();
      const countFrom = (arr = [], keys = []) => {
        const set = new Set(keys.map(norm));
        return arr.reduce((sum, it) => sum + (set.has(norm(it?.key)) ? Number(it?.value || 0) : 0), 0);
      };

      // ——— SADECE GÖRSELDE GÖSTERİLECEK 6 KATEGORİ ———
      const cards = [
        {
          label: "Kitaplar",
          value: countFrom(types, ["Akademik Kitap", "Popüler Kitap", "Populer Kitap"])
        },
        {
          label: "Kitap Bölümleri",
          value: countFrom(types, ["Akademik Kitap Bölümü", "Akademik Kitap Bolumu"])
        },
        {
          label: "Dergiler",
          value: journalCount,
        },
        {
          label: "Dergi Sayıları",
          value: countFrom(types, [
            "Popüler Dergi Yazısı",
            "Populer Dergi Yazısı",
            "Popüler Dergi Sayısı",
            "Akademik Dergi Sayısı"
          ])
        },
        {
          label: "Makaleler",
          value: countFrom(types, ["Akademik Makale"])
        },
        {
          label: "Konferans Bildirileri",
          value: countFrom(types, [
            "Konferans ve Armağan",
            "Konferans ve Armağan Yazısı",
            "Konferans ve Armagan",
            "Konferans ve Armagan Yazisi"
          ])
        }
      ].map(x => ({ ...x, value: Number(x.value) || 0 }));

      setCatAggs(cards);


      // Konu başlıkları (mevcut kodun)
      const topics = data?.publicationtypeInfo?.["Konu Başlıkları"] ?? [];
      const topicList = [
        "Bilgisayar Bilimleri",
        "Biyoloji",
        "Çevre ve Sürdürülebilirlik",
        "Çevre ve Tarım",
        "Davranış Bilimleri",
        "Dil ve Edebiyat",
        "Eğitim",
        "Ekonomi, Finans, İşletme",
        "Fen Bilimleri",
        "Gıda Bilimi ve Teknolojisi",
        "Halk Sağlığı ve Sosyal Hizmetler",
        "Hukuk",
        "İletişim Çalışmaları",
        "İnsan ve Toplum Bilimleri",
        "Kültürel Miras ve Müzecilik",
        "Matematik, İstatistik ve Veri Bilimi",
        "Mimarlık, Şehircilik",
        "Mühendislik ve Teknoloji",
        "Sanat",
        "Sağlık Bilimleri",
        "Spor ve Eğlence",
        "Sürdürülebilir Kalkınma ve Küresel Kalkınma",
        "Siyaset ve Uluslararası İlişkiler",
        "Turizm, Konaklama ve Etkinlikler",
        "Yer Bilimleri",
        "Askeri Bilimler",
        "Din",
        "Veterinerlik",
        // "Lojistik / Ulaşım"
      ].map(label => ({ label, value: 0 }));

      // const topicList = topics
      //   .map(t => ({ label: t.key, value: Number(t.value) || 0 }))
      //   .sort((a, b) => b.value - a.value);
      setTopicAggs(topicList);

      requestAnimationFrame(() => AOS.refresh());
    } catch {
      setCatAggs([]);
      console.error("Kategori aggr çekilemedi");
    } finally {
      setCatLoading(false);
    }
  };



  useEffect(() => {
    if (userDatabase !== null) loadCategoryAggs();
  }, [userDatabase]);

  useEffect(() => {
    document.body.className = "home-two";
    return () => {
      document.body.className = "";
    };
  }, []);
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await getPublicationTypeList();
        const data = res?.data ?? [];
        if (res.status && res.status !== "OK") return;

        // isim düzeltmeleri
        const fixed = data.map(it => {
          const web = it.webname === "EISSN" ? "E-ISSN"
            : it.webname === "EISBN" ? "E-ISBN"
              : it.webname;
          return { ...it, webname: web };
        });

        // "Dergi Adı" ekle (eğer yoksa)
        const dergiAdiExists = fixed.some(it => it.webname === "Dergi Adı");
        if (!dergiAdiExists) {
          fixed.push({
            webname: "Dergi Adı",
            typename: "parentList",
            attributename: "Dergi Adı"
          });
        }

        // sıralama
        const sortOrder = [
          "Tümü",
          "Başlık",
          "Anahtar Kelime",
          "Özet",
          // "Konu Başlıkları",
          "İçerik",
          "Yazar",
          "Dergi Adı",
          "ISBN",
          "ISSN",
          "E-ISBN",
          "E-ISSN"
        ];
        fixed.sort((a, b) => {
          const ia = sortOrder.indexOf(a.webname);
          const ib = sortOrder.indexOf(b.webname);
          if (ia === -1 && ib === -1) return a.webname.localeCompare(b.webname);
          if (ia === -1) return 1;
          if (ib === -1) return -1;
          return ia - ib;
        });

        // UI formatı (İçerik → Tam Metin)
        // Filtre: dropdown'da göstermemek istediğimiz webname'leri çıkaralım
        const excludeLower = new Set(["cilt", "sayı", "yayın yeri", "konu başlıkları"]);
        const formatted = fixed
          .filter(item => {
            const name = (item.webname || "").toString().trim().toLowerCase();
            return !excludeLower.has(name);
          })
          .map(item => ({
            value: item.attributename,                 // select value: attributename
            label: item.webname === "İçerik" ? "Tam Metin" : item.webname,
            typename: item.typename,
            attributename: item.attributename,
          }));

        // en başa "Tümü"
        const withAll = [
          { value: "", label: "Tümü", typename: "all", attributename: "" },
          ...formatted,
        ];

        // attributename’e göre tekilleştir
        const deduped = Array.from(
          new Map(withAll.map(o => [o.attributename, o])).values()
        );

        setOptions(deduped);
        setSelectedOption(deduped[0]); // "Tümü"yi seçili getir
      } catch (e) {
        console.error("Error fetching options:", e);
      }
    };
    fetchOptions();
  }, []);

  // Input referansı ve placeholder
  const inputRef = useRef(null);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Arama Terimi");

  const onCategoryClick = (label) => {
    // label → documentTypes eşleşmesi
    const map = {
      "Kitaplar": ["Akademik Kitap", "Popüler Kitap"],
      "Dergiler": ["Dergi"],
      "Özetler": ["Özet"],
      "Kitap Bölümleri": ["Akademik Kitap Bölümü"],
      "Popüler Makaleler": ["Popüler Dergi Yazısı", "Populer Dergi Yazısı"],
      "Akademik Makaleler": ["Akademik Makale"],
      "Konferans Bildirileri": ["Konferans Bildirisi"],
      "Dergi Sayıları": ["Popüler Dergi Sayısı", "Akademik Dergi Sayısı", "Dergi Sayısı"],
    };

    const updated = { ...selectedFilters, documentTypes: map[label] || [] };
    setSelectedFilters(updated);

    // doğrudan liste sayfasına da yönlendirmek istersen:
    // navigate("/publication-list?" + queryString.stringify({
    //   ... /* senin mevcut param kurgu */
    // }, { arrayFormat: "comma" }));
  };

  const onTopicClick = (topicLabel) => {
    // sadece bu konuyu filtrele
    setSelectedFilters(prev => ({
      ...prev,
      topicTitles: [topicLabel]
    }));

    // istersen direkt liste sayfasına yönlendir:
    // const params = {
    //   ... /* senin mevcut query kurgu */
    //   topicTitles: topicLabel,
    // };
    // navigate("/publication-list?" + queryString.stringify(params, { arrayFormat: "comma" }));
  };


  // Tümü moduna reset
  const setAllMode = () => {
    setQuickKind("all");
    setSearchPlaceholder("Arama Terimi");
    const allOpt =
      options.find(o => o.label === "Tümü" || o.attributename === "") || options[0];
    if (allOpt) setSelectedOption(allOpt);
  };

  const onQuickTag = (kind) => {
    // Aynı butona tekrar tıklanırsa Tümü'ne dön
    if (kind === quickKind) {
      setAllMode();
      return;
    }

    setQuickKind(kind);

    if (kind === "yazar") {
      setSearchPlaceholder("Yazar adı ara");
      setSelectedOption({
        value: "name",
        label: "Yazar",
        typename: "authors",
        attributename: "name",
      });
    } else if (kind === "dergi") {
      setSearchPlaceholder("Dergi adı ara");
      // select kullanmıyoruz; mantık aynı
    } else if (kind === "kitap") {
      setSearchPlaceholder("Kitap adı ara");
      setSelectedOption({
        value: "Başlık",
        label: "Başlık",
        typename: "publicationtypeInfo",
        attributename: "Başlık",
      });
    } else {
      setAllMode();
    }
  };


  const iconBarItems = [
    // Consolidated per design: two combined entries
    { id: "sureli-yayinlar", title: "İdealonline Süreli Yayınlar", icon: AkademikDergiler },
    { id: "sosyal-bilimler", title: "İdeal Sosyal Bilimler Veri Tabanı", icon: Kitaplar },
    { id: "tip-&-saglik-bilimleri", title: "Tıp Kitapları", icon: TipKitaplari },
    { id: "din-bilimleri", title: "Din Bilimleri", icon: DinBilimleri },
    { id: "konferans-&-armagan", title: "Konferans ve Armağanlar", icon: BildiriVeArmaganlar },
  ];

  // mapping from icon id -> database name to use in /database/{name}
  const iconDbMap = {
    // legacy mappings retained for other ids
    'akademik-dergiler': 'Akademik Dergiler',
    'populer-dergiler': 'Popüler Dergiler',
    'akademik-kitaplar': 'Akademik Kitap',
    'populer-kitaplar': 'Popüler Kitap',
    'tip-kitaplari': 'İdeal Tıp Kitapları',
    'din-bilimleri': 'Din Bilimleri',
    'bildiri-armagan': 'Konferans & Armağanlar',
    'sosyal-bilimler': 'İdeal Sosyal Bilimler Veritabanı',
  };



  useEffect(() => {
    const loadUserDatabase = async () => {
      try {
        const response = await userInstutationDatabases(auth.token);
        setFetchedDBs(response.data);
        const names = response.data.map((item) => item.name);
        setUserDatabase(names);
      } catch (error) {
        setUserDatabase([]);
      }
    };
    loadUserDatabase();
  }, [auth.token]);

  const loadPublications = async () => {
    setLoading(true);
    const headers = auth.token ? { Authorization: `Bearer ${auth.token}` } : {};

    try {
      const filtersToSend = { ...selectedFilters };

      if (filtersToSend.endyear === 0) delete filtersToSend.endyear;
      if (filtersToSend.startyear === 0) delete filtersToSend.startyear;

      // 👇 Burada yeni mantık uygulanıyor
      filtersToSend.databases = filtersToSend.databases.length > 0
        ? filtersToSend.databases
        : (userDatabase?.length > 0 ? userDatabase : []);

      const response = await axiosInstance.post(
        `publicationSearch/lastpublications/advantageSearchElastic`,
        filtersToSend,
        {
          params: {
            page: 1,
            newpagesize: 6,
            ordertype: "desc",
            orderfield: "mysqlId"
          },
          headers: headers,
        }
      );

      if (response.data && response.data.status === "OK") {
        setPublications(response.data.data);
      }
    } catch (error) {
      setPublications([]);
      console.error("Error fetching publications:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleTabClick = (type) => {
    setActiveTab(type);

    const updatedFilters = { ...selectedFilters };

    const tabMap = {
      "Makale ve Yazı": ["Akademik Makale", "Popüler Dergi Yazısı", "Populer Dergi Yazısı"],
      "Dergi": ["Dergi"],
      "Dergi Sayısı": ["Popüler Dergi Sayısı"],
      "Kitap": ["Akademik Kitap", "Popüler Kitap"],
      "Kitap Bölümü": ["Akademik Kitap Bölümü"],
      "Tümü": [],
    };

    updatedFilters.documentTypes = tabMap[type] || [];

    setSelectedFilters(updatedFilters);
  };


  useEffect(() => {
    if (userDatabase !== null) loadPublications();
  }, [userDatabase, selectedFilters]);

  const [aramaBarText, setAramaBarText] = useState("");

  const fetchAramaBarText = async () => {
    try {
      const response = await getAramaBarText();
      const aramaBarText = response?.data || [];
      setAramaBarText(aramaBarText);
    } catch (error) {
      console.error("Arama çubuğu metni alınamadı:", error);
    }
  };

  // Kartlar listesini al
  const [kartlar, setKartlar] = useState([]);
  const fetchKartlarList = async () => {
    try {
      const response = await getKartlarList();


      const kartlarData = response?.data || [];
      setKartlar(kartlarData);
    } catch (error) {
      console.error("Kartlar verisi alınamadı:", error);
      setKartlar([]);
    }
  };

  const [bilgiKaynaklarimizText, setBilgiKaynaklarimizText] = useState([]);

  const fetchBilgiKaynaklarimiz = async () => {
    try {
      const response = await getBilgiKaynaklarimiz();
      setBilgiKaynaklarimizText(response.data || []);
    } catch (error) {
      console.error("Kartlar verisi alınamadı:", error);
      setBilgiKaynaklarimizText([]);
    }
  };

  useEffect(() => {
    fetchAramaBarText();
    fetchKartlarList();
    fetchBilgiKaynaklarimiz();
  }, []);

  const handleSubmit = (event, type, selectedOption) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const q = (formData.get("query") || "").trim();

    // --- QUICK MODLAR ---
    if (quickKind === "dergi") {
      // dergi araması database route'unda
      navigate(`/journal-list/all`, {
        state: {
          databasename: "",
          searchkeyword: q || "",
          topicname: "",
          searchtype: q ? "journalName" : "",
        },
      });
      return;
    }

    if (quickKind === "yazar") {
      const queries = [
        { typename: "authors", attributename: "name", searchkeyword: q || "*", operator: "or" },
      ];
      const params = {
        publicationAdvantageSearchDTOList: encodeURIComponent(JSON.stringify(queries)),
        permission: -1, databases: "", languages: "", journals: "", keywords: "",
        publishers: "", topicTitles: "", documentTypes: "", startyear: "", endyear: "",
        status: 1, pdffile: -1, identifier: "", attributename: "name"
      };
      navigate("/publication-list?" + queryString.stringify(params, { arrayFormat: "none" }));
      return;
    }

    if (quickKind === "kitap") {
      const queries = [
        { typename: "publicationtypeInfo", attributename: "Başlık", searchkeyword: q || "*", operator: "or" },
      ];
      const params = {
        publicationAdvantageSearchDTOList: encodeURIComponent(JSON.stringify(queries)),
        documentTypes: ["Akademik Kitap", "Popüler Kitap"],
        permission: -1, databases: "", languages: "", journals: "", keywords: "",
        publishers: "", topicTitles: "", startyear: "", endyear: "",
        status: 1, pdffile: -1, identifier: "", attributename: "Başlık"
      };
      navigate("/publication-list?" + queryString.stringify(params, { arrayFormat: "none" }));
      return;
    }

    // --- "Dergi Adı" seçiliyse journal-list/all'a git ---
    if (selectedOption?.attributename === "Dergi Adı") {
      navigate(`/journal-list/all`, {
        state: {
          databasename: "",
          searchkeyword: q || "",
          topicname: "",
          searchtype: q ? "journalName" : "",
        },
      });
      return;
    }

    // --- STANDART (all) ---
    const isIssnSearch = selectedOption?.attributename === "ISSN" || selectedOption?.attributename === "E-ISSN" || selectedOption?.attributename === "EISSN";

    const queries = [];
    if (isIssnSearch) {
      queries.push({
        typename: "all",
        attributename: "",
        searchkeyword: "*",
        operator: "or",
      });
    } else if (selectedOption?.typename?.includes(",")) {
      selectedOption.typename.split(",").forEach((typename) => {
        queries.push({
          typename,
          attributename: selectedOption?.attributename || "",
          searchkeyword: q || "*",
          operator: "or",
        });
      });
    } else {
      queries.push({
        typename: selectedOption?.typename || "all",
        attributename: selectedOption?.attributename || "",
        searchkeyword: q || "*",
        operator: "or",
      });
    }

    const params = {
      publicationAdvantageSearchDTOList: encodeURIComponent(JSON.stringify(queries)),
      permission: -1,
      databases: "",
      languages: "",
      journals: isIssnSearch ? q || "" : "",
      keywords: "",
      publishers: "",
      topicTitles: "",
      documentTypes: "",
      startyear: "",
      endyear: "",
      status: 1,
      pdffile: -1,
      identifier: "",
      attributename: selectedOption?.attributename || ""
    };
    navigate("/publication-list?" + queryString.stringify(params, { arrayFormat: "none" }));
  };


  // Update handleMagazineSearch for new logic
  const handleMagazineSearch = (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const magazine = formData.get("magazine") || "";
    const databasename = formData.get("databasename") || selectedDatabase || "";


    // Tümü (boş değer) seçiliyse all route'una git
    if (!databasename) {
      navigate(`/journal-list/all`, {
        state: {
          databasename: "",
          searchkeyword: magazine || "",
          topicname: "",
          searchtype: magazine ? "journalName" : "",
        },
      });
      return;
    }

    if (databasename) {
      if (magazine) {
        navigate(`/database/${encodeURIComponent(databasename)}`, {
          state: {
            databasename,
            searchkeyword: magazine,
            topicname: "",
            searchtype: "journalName",
          },
        });
      } else {
        navigate(`/database/${encodeURIComponent(databasename)}`, {
          state: {
            databasename,
            searchkeyword: "",
            topicname: "",
            searchtype: "",
          },
        });
      }
    }
  };

  // Kitap sekmesi için arama fonksiyonu
  const handleBookSearch = (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const bookName = formData.get("book") || "";
    // publicationAdvantageSearchDTOList sadece başlık aramasını içersin
    const queries = [];
    if (bookName) {
      queries.push({
        typename: "publicationtypeInfo",
        attributename: "Başlık",
        searchkeyword: bookName,
        operator: "or",
      });
    } else {
      queries.push({
        typename: "publicationtypeInfo",
        attributename: "Başlık",
        searchkeyword: "*",
        operator: "or",
      });
    }
    // URL parametrelerini hazırla
    const params = {
      publicationAdvantageSearchDTOList: encodeURIComponent(JSON.stringify(queries)),
      documentTypes: ["Akademik Kitap", "Popüler Kitap"],
      permission: -1,
      databases: "",
      languages: "",
      journals: "",
      keywords: "",
      publishers: "",
      topicTitles: "",
      startyear: "",
      endyear: "",
      status: 1,
      pdffile: -1,
      identifier: "",
      attributename: "Başlık"
    };
    navigate("/publication-list?" + queryString.stringify(params, { arrayFormat: "none" }));
  };


  const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    speed: 600,
    arrows: true,

    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleAllPublications = () => {
    const queries = [
      {
        typename: "all",
        attributename: "",
        searchkeyword: "*",
        operator: "or",
      },
    ];
    // navigate("/publication-list", {
    //   state: { publicationAdvantageSearchDTOList: queries },
    // });
    // --- YENİ: Query string ile gönder ---
    const params = {
      publicationAdvantageSearchDTOList: encodeURIComponent(JSON.stringify(queries)),
      permission: -1,
      databases: "",
      languages: "",
      journals: "",
      keywords: "",
      publishers: "",
      topicTitles: "",
      documentTypes: "",
      startyear: "",
      endyear: "",
      status: 1,
      pdffile: -1,
      identifier: "",
      attributename: ""
    };
    navigate("/publication-list?" + queryString.stringify(params, { arrayFormat: "none" }));
  };

  const aosDelay = (i, step = 60, max = 420) => Math.min(i * step, max);

  return (

    <div className=" io-home"> {/* 👈 scope kökü */}
      <Helmet>
        <title>İdealonline - Ana Sayfa</title>
      </Helmet>
      <Header />

      <section className="io-hero d-flex align-items-center "
        style={{
          backgroundImage: `url(${Halkalar})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          backgroundSize: "65%", // 👈 boyutu küçültür (oranlı)
          backgroundColor: "#f9f9f9"
        }}>
        <div className="container">
          <div className="row"
          >
            <div className="col-lg-12 col-12">
              <div className="home-slide-face mt-3">
                <div className="text-center io-hero-title" data-aos="fade-up" data-aos-delay="0">
                  <h1>Akademik Yayınlara<br />Kolay ve Hızlı Erişim</h1>
                  <p className="io-hero-sub">
                    {aramaBarText?.content || "İhtiyacınız olan akademik içerikleri hızla bulun ve keşfedin."}
                  </p>
                </div>

                {/* === ARAMA ALANI === */}
                <div className="io-search shadow-lg" data-aos="fade-up" data-aos-delay="150">
                  <form onSubmit={(e) => handleSubmit(e, "all", selectedOption)}>
                    <div className="io-search-row">
                      <div className="io-search-input">
                        <i className="fa-solid fa-magnifying-glass text-lg text-dark" />
                        <input
                          ref={inputRef}
                          type="text"
                          name="query"
                          placeholder={searchPlaceholder}
                          autoComplete="off"
                        />

                      </div>

                      {/* KATEGORİ (yalnızca quickKind === 'all' iken göster) */}
                      {quickKind === 'all' && (
                        <div className="io-cat">
                          <i className="fa-solid fa-bars" />
                          <span className="io-cat-label">
                            {selectedOption?.label || "Kategoriler"}
                          </span>
                          <i className="fa-solid fa-chevron-down ms-2 d-none d-sm-inline" />
                          <select
                            aria-label="Kategoriler"
                            value={selectedOption ? selectedOption.value : ""}
                            onChange={(e) => {
                              const s = options.find(o => o.value === e.target.value);
                              setSelectedOption(s || options[0]);
                            }}
                          >
                            {options.map((opt) => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      <button className="io-btn io-btn--primary" type="submit">
                        Ara
                      </button>

                    </div>
                  </form>
                </div>
                {/* === Hızlı linkler: Yazar · Dergi · Kitap === */}
                <div className="io-quick" data-aos="fade-up" data-aos-delay="300">
                  {/* <button type="button" className={`io-quick__item ${quickKind === 'yazar' ? 'is-active' : ''}`} onClick={() => onQuickTag("yazar")}>
                    Yazar
                  </button>
                  <button type="button" className={`io-quick__item ${quickKind === 'dergi' ? 'is-active' : ''}`} onClick={() => onQuickTag("dergi")}>
                    Dergi
                  </button>
                  <button type="button" className={`io-quick__item ${quickKind === 'kitap' ? 'is-active' : ''}`} onClick={() => onQuickTag("kitap")}>
                    Kitap
                  </button> */}
                  <button type="button" className={`io-quick__item`} onClick={() => navigate("/advanced-search")}>
                    Detaylı Arama
                  </button>
                </div>

                {/* Popüler kısa linkler istersen buraya ekleyebilirsin */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== AYIRICI ===== */}
      {/* <div className="io-sep" /> */}


      {/* ==== İKONLU KATEGORİ BARI ==== */}
      <section className="io-iconbar">
        <div className="container">
          <div className="io-iconbar-row" data-aos="fade-up" data-aos-delay="450">
            {iconBarItems.map(item => {
              if (item.id === 'sureli-yayinlar') {
                return (
                  <Link
                    key={item.id}
                    to={`/journal-list/all`}
                    className="io-ibox"
                    role="img"
                    aria-label={item.title}
                  >
                    <span className="io-ibox__circle">
                      <img src={item.icon} alt={item.title} />
                    </span>
                    <span className="io-ibox__title">{item.title}</span>
                  </Link>
                );
              }
              console.log(iconDbMap);
              const dbName = iconDbMap[item.id];
              return (
                <Link
                  key={item.id}
                  to={`/database/${item.id}`}
                  className="io-ibox"
                  role="img"
                  aria-label={item.title}
                >
                  <span className="io-ibox__circle">
                    <img src={item.icon} alt={item.title} />
                  </span>
                  <span className="io-ibox__title">{item.title}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* ==== KATEGORİLERE GÖRE İNCELE ==== */}
      <section className="io-catgrid">
        <div className="io-catgrid__container" data-aos="fade-up" data-aos-delay="600">
          <h2 className="io-catgrid__title">Kategorilere Göre İncele</h2>
          <p className="io-catgrid__sub">İlgi alanınıza uygun yayınları kolayca bulmak için kategoriler arasından seçim yapın!</p>

          {catLoading ? (
            <OrangeSpinner />
          ) : (
            <div className="io-catgrid__grid">
              {catLoading ? (
                <OrangeSpinner />
              ) : (
                catAggs.map(({ label, value }) => (
                  <div
                    key={label}
                    className="io-catcard"
                    tabIndex={0}
                    aria-label={`${label} (${value})`}
                  >
                    <div className="io-catcard__inner">
                      <div className="io-catcard__texts">
                        <div className="io-catcard__heading">{label}</div>
                        <div className="io-catcard__desc">
                          {value !== null && value !== undefined ? `${Number(value).toLocaleString("tr-TR")} yayın mevcut` : "Yükleniyor..."}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

          )}
        </div>
      </section>


      {/* ==== KONULARA GÖRE İNCELE ==== */}
      <section className="io-topicgrid">
        <div className="io-topicgrid__container" data-aos="fade-up">
          <h2 className="io-topicgrid__title">Konulara Göre İncele</h2>
          <p className="io-topicgrid__sub">İlgi alanlarına göre yayınları hızlıca keşfet</p>

          {!topicAggs.length ? (
            <div className="text-muted">Konu başlığı bulunamadı.</div>
          ) : (
            <div className="io-topicgrid__grid">
              {splitToCols(topicAggs, 4).map((col, colIdx) => (
                <ul key={colIdx} className="io-topiclist">
                  {col.map(({ label, value }) => (
                    <li key={label}>
                      <a
                        className="io-topiclist__item"
                        // href="#"
                        // onClick={(e) => { e.preventDefault(); onTopicClick(label); }}
                        aria-label={`${label} (${value.toLocaleString("tr-TR")} yayın)`}
                        title={`${value.toLocaleString("tr-TR")} yayın`}
                      >
                        {label}
                      </a>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          )}
        </div>
      </section>


      {/* Son Eklenen Yayınlar */}
      <section className="io-latest">
        <div className="io-latest__container" data-aos="fade-up">

          <div className="io-latest__head">
            <div className="io-latest__title">
              <h2>Son Eklenen Yayınlar</h2>
              <p>Yeni eklenen kitap, dergi, makale ve daha birçok yayını keşfedin!</p>
            </div>

            <div className="io-chiplist" role="tablist" aria-label="Yayın türü">
              {["Tümü", "Makale ve Yazı", "Dergi Sayısı", "Kitap", "Kitap Bölümü"].map((type) => (
                <button
                  key={type}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === type}
                  className={`io-chip ${activeTab === type ? "is-active" : ""}`}
                  onClick={() => handleTabClick(type)}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <OrangeSpinner />
          ) : (
            <div className="io-pubgrid">
              {publication.slice(0, 6).map((pub, index) => {
                if (!pub) return null;

                const title =
                  pub.publicationtypeInfo.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0] ||
                  pub.templateInfo.find(a => a.attributename === "Başlık")?.value?.[0]?.value?.[0] || "";

                const authors =
                  pub.authors?.map(a => `${a.name} ${a.surname}`).join(", ") || "";

                const publicationtype = pub.publicationtype || "";
                const coverImage = pub.coverimage
                  ? `https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${pub.mysqlId}/${pub.coverimage}`
                  : Course10;
                const id = pub.mysqlId;

                const titleUrl = `/publication-details/${id}`;

                // örnek tek etiket (istersen pub.topics / keywords'ten doldurabilirsin)
                const tags = pub.keywords?.slice(0, 2) || [];

                // yayın tarihi (sağ altta) – varsa al

                // const rightDate = getDateLoose(pub);
                const rightDate = "";

                return (
                  <div className="io-pubcard" key={index}>
                    <div className="io-pubcard__top">
                      <div className="io-thumb">
                        <a href={titleUrl} target="_blank" rel="noopener noreferrer">
                          <ChapterCover pub={pub} auth={auth} />
                        </a>
                      </div>

                      <div className="io-meta">
                        {publicationtype && <div className="io-type">{normalizeTypeDisplay(publicationtype)}</div>}

                        <a className="io-title" href={titleUrl} target="_blank" rel="noopener noreferrer" title={title}>
                          {title}
                        </a>

                        <div className="io-submeta">
                          {(() => {
                            const parts = buildInlineParts(pub);
                            const t = pub?.publicationtype?.toLocaleLowerCase("tr-TR") || "";

                            if (!parts.length) return null;

                            const isBookSection = t.includes("bölüm");
                            const isArticle = t.includes("makale") || t.includes("yazı");
                            const isIssue = t.includes("sayı");

                            // Makale ve Sayı için genellikle index 1 veya 0 dergidir
                            const journalTitle = getParentTitle(pub, 1) || getParentTitle(pub, 0);
                            const journalId = pub?.parentList?.[1]?.mysqlId || pub?.parentList?.[0]?.mysqlId;

                            // Kitap Bölümü için index 0 kitaptır
                            const bookTitle = getParentTitle(pub, 0);
                            const bookId = pub?.parentList?.[0]?.mysqlId;

                            // Link render fonksiyonu
                            const renderLinkedPart = (p) => {
                              // Makale/Sayı ise ve p dergi adıysa linkle
                              if ((isArticle || isIssue) && p === journalTitle && journalId) {
                                return (
                                  <Link
                                    to={`/publication-details/${journalId}`}
                                    className="io-submeta__link"
                                    style={{ color: 'inherit', textDecoration: 'none' }}
                                    onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                    onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                                  >
                                    {p}
                                  </Link>
                                );
                              }
                              // Kitap bölümü ise ve p kitap adıysa linkle
                              if (isBookSection && p === bookTitle && bookId) {
                                return (
                                  <Link
                                    to={`/publication-details/${bookId}`}
                                    className="io-submeta__link"
                                    style={{ color: 'inherit', textDecoration: 'none' }}
                                    onMouseOver={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                    onMouseOut={(e) => e.currentTarget.style.textDecoration = 'none'}
                                  >
                                    {p}
                                  </Link>
                                );
                              }
                              return p;
                            };

                            if (isBookSection && parts.length >= 2) {
                              const mainParts = parts.slice(0, -1);
                              const publisher = parts[parts.length - 1];

                              return (
                                <>
                                  {mainParts.map((p, i) => (
                                    <span key={i} className="io-submeta__org">
                                      {renderLinkedPart(p)}
                                      {i < mainParts.length - 1 ? " | " : ""}
                                    </span>
                                  ))}
                                  <span className="io-submeta__publisher">{publisher}</span>
                                </>
                              );
                            }

                            return parts.map((p, i) => (
                              <span key={i} className="io-submeta__org">
                                {renderLinkedPart(p)}
                                {i < parts.length - 1 ? " | " : ""}
                              </span>
                            ));
                          })()}
                        </div>


                      </div>
                    </div>

                    {/* etiketler */}
                    {tags.length > 0 && (
                      <div className="io-tags">
                        {tags.map((t, i) => (
                          <span className="io-tag" key={i}>{t}</span>
                        ))}
                      </div>
                    )}

                    <div className="io-cardfooter">
                      <span>{rightDate}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="text-center mt-4">
            <Link
              to="#"
              onClick={(e) => { e.preventDefault(); handleAllPublications(); }}
              className="io-btn io-btn--primary io-btn--lg mb-4"
            >
              Tüm Yayınlar <i className="fas fa-arrow-right ms-2" />
            </Link>
          </div>

        </div>
      </section>

      {/* === İdealonline ile neler yapabilirim? === */}
      <section className="io-benefits">
        <div className="io-benefits__container" data-aos="fade-up">
          <header className="io-benefits__head">
            <h2>İdealonline ile neler yapabilirim?</h2>
            <p>İdealOnline ile binlerce akademik yayına erişebilir, farklı disiplinlerde araştırmalarını kolayca sürdürebilirsin.</p>
          </header>

          <ul className="io-benefits__grid">
            <li className="io-benefit">
              <span className="io-benefit__icon">
                <img src={KolayErisim} alt="Kolay Erişim" />
              </span>
              <h3 className="io-benefit__title">Kolay Erişim</h3>
              <p className="io-benefit__desc">
                Aradığınız yayınlara hızlıca ulaşmanızı sağlayan gelişmiş arama ve filtreleme seçenekleriyle zaman kazanın.
              </p>
            </li>

            <li className="io-benefit">
              <span className="io-benefit__icon">
                <img src={GuvenilirIcerik} alt="Güvenilir İçerik" />
              </span>
              <h3 className="io-benefit__title">Güvenilir İçerik</h3>
              <p className="io-benefit__desc">
                Sürekli güncellenen, akademik standartlara uygun ve güvenilir kaynaklarla araştırmalarınızı destekleyin.
              </p>
            </li>

            <li className="io-benefit">
              <span className="io-benefit__icon">
                <img src={KonuYelpazesi} alt="Geniş Konu Yelpazesi" />
              </span>
              <h3 className="io-benefit__title">Geniş Konu Yelpazesi</h3>
              <p className="io-benefit__desc">
                Farklı disiplinlerden binlerce dergi, makale ve kitapla kapsamlı bir akademik kaynak havuzuna erişin.
              </p>
            </li>

            <li className="io-benefit">
              <span className="io-benefit__icon">
                <img src={DostuArayuz} alt="Kullanıcı Dostu Arayüz" />
              </span>
              <h3 className="io-benefit__title">Kullanıcı Dostu Arayüz</h3>
              <p className="io-benefit__desc">
                Basit ve modern tasarımıyla aradığınız bilgilere kolayca ulaşıp araştırmalarınızı verimli şekilde sürdürebilirsiniz.
              </p>
            </li>
          </ul>

        </div>
      </section>
      {/* === Nasıl Çalışır? === */}
      <section className="io-how">
        <div className="io-how__container" data-aos="fade-up">
          <header className="io-how__head">
            <h2>Nasıl Çalışır?</h2>
            <p>İdealOnline'ı kullanmaya başlamak çok kolay! Adımları takip ederek akademik yayınlara hızlıca erişebilirsiniz.</p>
          </header>

          <ol className="io-how__grid">
            <li className="io-step">
              <span className="io-step__icon">
                <i className="fa-solid fa-user-plus" aria-hidden="true"></i>
              </span>
              <h3 className="io-step__title">1. Kayıt Ol</h3>
              <p className="io-step__desc">
                IDEAL’e kurumunuz aracılığıyla abone olun, binlerce akademik yayına kolayca erişim sağlayın.
              </p>
            </li>

            <li className="io-step">
              <span className="io-step__icon">
                <i className="fa-solid fa-list-check" aria-hidden="true"></i>
              </span>
              <h3 className="io-step__title">2. Kategorini Seç</h3>
              <p className="io-step__desc">
                İlgi alanına en uygun kategoriyi seçerek farklı disiplinlerdeki yayınları keşfetmeye başla.
              </p>
            </li>

            <li className="io-step">
              <span className="io-step__icon">
                <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
              </span>
              <h3 className="io-step__title">3. Yayınları Araştır</h3>
              <p className="io-step__desc">
                Gelişmiş arama ve filtreleme seçenekleriyle aradığın makale, kitap veya raporu kolayca bul.
              </p>
            </li>

            <li className="io-step">
              <span className="io-step__icon">
                <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
              </span>
              <h3 className="io-step__title">4. İçeriğe Eriş</h3>
              <p className="io-step__desc">
                Seçtiğin yayının özet ve detaylarını incele, ihtiyaç duyduğun bilgilere ulaş ve güvenle kullan.
              </p>
            </li>
          </ol>
        </div>
      </section>

      {/* === Bilgi Kaynaklarımız === */}
      <section className="io-sources">
        <div className="io-sources__container" data-aos="fade-up">
          <div className="io-sources__col io-sources__col--left">
            <h2>Bilgi Kaynaklarımız</h2>
            <p>
              IDEAL, farklı disiplinlerde binlerce yayını içeren kapsamlı veri tabanlarıyla
              araştırmacılara güvenilir ve güncel bilgi kaynakları sunar.
            </p>

            <div className="io-sources__illu">
              <img
                src={BilgiKaynaklarimiz}
                alt="Veri Tabanlarımız illüstrasyonu"
                loading="lazy"
              />
            </div>
          </div>

          <div className="io-sources__col io-sources__col--right">
            <ul className="io-sources__list">
              {bilgiKaynaklarimizText.map((item, index) => (
                <li key={index} className="io-sources__item">
                  <span className="io-sources__icon">
                    <img
                      src={
                        index === 0 ? AkademikDergiler :
                          index === 1 ? PopulerDergiler :
                            index === 2 ? TipKitaplari :
                              index === 3 ? BildiriVeArmaganlar :
                                index === 4 ? DinBilimleri :
                                  AkademikDergiler
                      }
                      alt={item.title}
                    />
                  </span>

                  <div className="io-sources__texts">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* ▼▼▼ BURASI YENİ: aynı sekmenin içinde tam genişlik fayda kartları ▼▼▼ */}
          <div className="io-sources__benefits">
            <article className="io-bcard">
              <div className="io-bcard__icon"><img src={HizlicaBulun} alt="" /></div>
              <header className="io-bcard__head"><h3>Aradığınız Kaynağı<br />Kolayca Bulun</h3></header>
              <p className="io-bcard__desc">
                Gelişmiş arama motoru ve kapsamlı filtreleme seçenekleri sayesinde ihtiyacınız olan makale,
                kitap ya da dergiye birkaç adımda ulaşabilirsiniz. Araştırmalarınızda zaman kaybetmeden
                doğru kaynağı bulmak artık çok daha kolay.
              </p>
            </article>

            <article className="io-bcard">
              <div className="io-bcard__icon"><img src={VerimliKullanin} alt="" /></div>
              <header className="io-bcard__head"><h3>Zamanınızı<br />Verimli Kullanın</h3></header>
              <p className="io-bcard__desc">
                Kullanıcı dostu arayüz ve hızlı erişim imkânı ile araştırmalarınızı daha kısa sürede tamamlayın.
                Gereksiz karmaşadan uzak, pratik çözümler sunan sistemimiz sayesinde akademik çalışmalarınıza
                daha fazla odaklanabilirsiniz.
              </p>
            </article>

            <article className="io-bcard">
              <div className="io-bcard__icon"><img src={HaberdarOlun} alt="" /></div>
              <header className="io-bcard__head"><h3>Gelişmelerden<br />Haberdar Olun</h3></header>
              <p className="io-bcard__desc">
                Sürekli güncellenen içerik havuzumuz ile yeni yayınlardan ve akademik dünyadaki önemli
                gelişmelerden ilk siz haberdar olun. Böylece araştırmalarınızı en güncel bilgiler ışığında
                sürdürerek çalışmalarınıza değer katabilirsiniz.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* === Referanslar şeridi === */}
      <section className="io-refbar">
        <div className="io-refbar__container" data-aos="fade-up">
          <h3 className="io-refbar__title">
            100’den fazla akademik kurum İdealonline'ı tercih etti...
          </h3>

          <Link to="/references" className="io-refbar__link">
            Tüm Referanslarımız
            <span className="io-refbar__chev" aria-hidden="true">›</span>
          </Link>
        </div>
      </section>

      <section className="io-reflogos">
        <div className="io-reflogos__container" data-aos="fade-up">
          {refLogos.map((it, i) => (
            <div key={i} className="io-reflogo">
              <img src={it.src} alt={it.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </section>




      {/* ===== AYIRICI ===== */}
      <div className="io-sep" />
      <Footer2 />
    </div>
  );
};
